import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Loader from '../../layout/Loder';
import { logout } from '../../actions/userAction';
import './Account.css';

const initialsOf = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Account = () => {
  const { user, loading, isAuthenticated } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoutLoading, setLogoutLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated === false) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      setLogoutLoading(true);
      await dispatch(logout());
    } catch (err) {
      toast.error(typeof err === 'string' ? err : 'Logout failed');
    } finally {
      setLogoutLoading(false);
    }
  };

  if (loading || !user) return <Loader />;

  const joined = user.createdAt ? moment(user.createdAt) : null;
  const dob = user.dob ? moment(user.dob).format('DD MMM YYYY') : null;

  return (
    <>
      <Helmet><title>Account · dmyor</title></Helmet>

      <div className="acc-page">
        <div className="acc-wrap">
          <header className="acc-header">
            <div className="acc-avatar" aria-hidden="true">
              {initialsOf(user.name)}
            </div>
            <div className="acc-identity">
              <h1 className="acc-name">{user.name || 'Unnamed'}</h1>
              <p className="acc-email">{user.email}</p>
              {joined && (
                <p className="acc-joined">
                  On dmyor since {joined.format('MMM YYYY')}
                </p>
              )}
            </div>
          </header>

          <section className="acc-card">
            <div className="acc-card-title">Details</div>

            <div className="acc-row">
              <span className="acc-row-label">Name</span>
              <span className="acc-row-value">{user.name || '—'}</span>
            </div>

            <div className="acc-row">
              <span className="acc-row-label">Email</span>
              <span className="acc-row-value">{user.email}</span>
            </div>

            {dob && (
              <div className="acc-row">
                <span className="acc-row-label">Date of birth</span>
                <span className="acc-row-value">{dob}</span>
              </div>
            )}

            {joined && (
              <div className="acc-row">
                <span className="acc-row-label">Member since</span>
                <span className="acc-row-value">{joined.format('DD MMM YYYY')}</span>
              </div>
            )}
          </section>

          <div className="acc-footer">
            <button
              type="button"
              className="acc-logout"
              onClick={handleLogout}
              disabled={logoutLoading}
            >
              <i className="bx bx-log-out" />
              {logoutLoading ? 'Logging out…' : 'Log out'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;
